import i18next from 'i18next'
import { List, Map } from 'immutable'
import once from 'lodash-es/once'
import { Department } from '../../types/coreEntitiesTypes'
import { DepartmentType } from '../../utils/departmentAndDepartmentGroupUtils'
import { ISize, PresetDimension } from './bookingOrderTypes'

export const shdMeasurements = List<ISize>([
  Map({ id: 0, presetDimension: 'custom', name: 'Custom', weight: '', length: '', width: '', height: '' }),
  Map({
    id: 1,
    presetDimension: 'fullpallet',
    name: 'Full pallet',
    weight: '200',
    length: '80',
    width: '120',
    height: '70'
  }),
  Map({ id: 2, presetDimension: 'parcel', name: 'Parcel', weight: '10', length: '20', width: '50', height: '30' })
])

// Built on first use, not on import: this module loads at startup, before i18next has the user's language
const parcelHubMeasurements = once(() =>
  List<ISize>([
    Map({
      id: 13,
      presetDimension: '9A',
      name: i18next.t('instant.goods.9A'),
      weight: 432,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 14,
      presetDimension: '9C',
      name: i18next.t('instant.goods.9C'),
      weight: 150,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 15,
      presetDimension: '9F',
      name: i18next.t('instant.goods.9F'),
      weight: 185,
      length: 80,
      width: 60,
      height: 120,
      goodsDescription: '',
      palletFootPrints: 0.5,
      loadingMeters: 0.2
    }),
    Map({
      id: 16,
      presetDimension: '9J',
      name: i18next.t('instant.goods.9J'),
      weight: 700,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 17,
      presetDimension: 'PX',
      name: i18next.t('instant.goods.PX'),
      weight: 700,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 18,
      presetDimension: 'PA',
      name: i18next.t('instant.goods.PA'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 19,
      presetDimension: 'AF',
      name: i18next.t('instant.goods.AF'),
      weight: 185,
      length: 80,
      width: 60,
      height: 120,
      goodsDescription: '',
      palletFootPrints: 0.5,
      loadingMeters: 0.2
    }),
    Map({
      id: 20,
      presetDimension: 'SA',
      name: i18next.t('instant.goods.SA'),
      weight: 23,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.1,
      loadingMeters: 0.0
    }),
    Map({
      id: 21,
      presetDimension: 'CS',
      name: i18next.t('instant.goods.CS'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 22,
      presetDimension: '9N',
      name: i18next.t('instant.goods.9N'),
      weight: 575,
      length: 120,
      width: 120,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.4,
      loadingMeters: 0.6
    }),
    Map({
      id: 23,
      presetDimension: '9O',
      name: i18next.t('instant.goods.9O'),
      weight: 155,
      length: 120,
      width: 120,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.4,
      loadingMeters: 0.6
    }),
    Map({
      id: 24,
      presetDimension: '9B',
      name: i18next.t('instant.goods.9B'),
      weight: 432,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 25,
      presetDimension: '9D',
      name: i18next.t('instant.goods.9D'),
      weight: 432,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 26,
      presetDimension: '9E',
      name: i18next.t('instant.goods.9E'),
      weight: 185,
      length: 80,
      width: 60,
      height: 120,
      goodsDescription: '',
      palletFootPrints: 0.5,
      loadingMeters: 0.2
    }),
    Map({
      id: 27,
      presetDimension: '9G',
      name: i18next.t('instant.goods.9G'),
      weight: 13,
      length: 80,
      width: 60,
      height: 15,
      goodsDescription: '',
      palletFootPrints: 0.5,
      loadingMeters: 0.2
    }),
    Map({
      id: 28,
      presetDimension: '9H',
      name: i18next.t('instant.goods.9H'),
      weight: 185,
      length: 80,
      width: 60,
      height: 120,
      goodsDescription: '',
      palletFootPrints: 0.5,
      loadingMeters: 0.2
    }),
    Map({
      id: 29,
      presetDimension: '9I',
      name: i18next.t('instant.goods.9I'),
      weight: 700,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 30,
      presetDimension: '9K',
      name: i18next.t('instant.goods.9K'),
      weight: 25,
      length: 120,
      width: 80,
      height: 15,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 31,
      presetDimension: '9L',
      name: i18next.t('instant.goods.9L'),
      weight: 700,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 32,
      presetDimension: '9M',
      name: i18next.t('instant.goods.9M'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 33,
      presetDimension: '9P',
      name: i18next.t('instant.goods.9P'),
      weight: 500,
      length: 180,
      width: 80,
      height: 100,
      goodsDescription: '',
      palletFootPrints: 1.4,
      loadingMeters: 0.6
    }),
    Map({
      id: 34,
      presetDimension: '9Q',
      name: i18next.t('instant.goods.9Q'),
      weight: 250,
      length: 120,
      width: 80,
      height: 100,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 35,
      presetDimension: '9Z',
      name: i18next.t('instant.goods.9Z'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 36,
      presetDimension: 'BE',
      name: i18next.t('instant.goods.BE'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 37,
      presetDimension: 'BG',
      name: i18next.t('instant.goods.BG'),
      weight: 23,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.1,
      loadingMeters: 0.0
    }),
    Map({
      id: 38,
      presetDimension: 'BX',
      name: i18next.t('instant.goods.BX'),
      weight: 13,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.1,
      loadingMeters: 0.0
    }),
    Map({
      id: 39,
      presetDimension: 'CD',
      name: i18next.t('instant.goods.CD'),
      weight: 1029,
      length: 120,
      width: 100,
      height: 100,
      goodsDescription: '',
      palletFootPrints: 1.2,
      loadingMeters: 0.5
    }),
    Map({
      id: 40,
      presetDimension: 'CL',
      name: i18next.t('instant.goods.CL'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 41,
      presetDimension: 'CN',
      name: i18next.t('instant.goods.CN'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 42,
      presetDimension: 'CR',
      name: i18next.t('instant.goods.CR'),
      weight: 37,
      length: 120,
      width: 80,
      height: 120,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 43,
      presetDimension: 'CT',
      name: i18next.t('instant.goods.CT'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 44,
      presetDimension: 'CW',
      name: i18next.t('instant.goods.CW'),
      weight: 432,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 45,
      presetDimension: 'DR',
      name: i18next.t('instant.goods.DR'),
      weight: 250,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.5,
      loadingMeters: 0.0
    }),
    Map({
      id: 46,
      presetDimension: 'ED',
      name: i18next.t('instant.goods.ED'),
      weight: 296,
      length: 127,
      width: 80,
      height: 82,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 47,
      presetDimension: 'LT',
      name: i18next.t('instant.goods.LT'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 48,
      presetDimension: 'OA',
      name: i18next.t('instant.goods.OA'),
      weight: 93,
      length: 60,
      width: 40,
      height: 120,
      goodsDescription: '',
      palletFootPrints: 0.2,
      loadingMeters: 0.1
    }),
    Map({
      id: 49,
      presetDimension: 'OC',
      name: i18next.t('instant.goods.OC'),
      weight: 875,
      length: 120,
      width: 100,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.2,
      loadingMeters: 0.5
    }),
    Map({
      id: 50,
      presetDimension: 'OT',
      name: i18next.t('instant.goods.OT'),
      weight: 740,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 51,
      presetDimension: 'PB',
      name: i18next.t('instant.goods.PB'),
      weight: 370,
      length: 120,
      width: 100,
      height: 100,
      goodsDescription: '',
      palletFootPrints: 1.2,
      loadingMeters: 0.5
    }),
    Map({
      id: 52,
      presetDimension: 'PC',
      name: i18next.t('instant.goods.PC'),
      weight: 8,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 53,
      presetDimension: 'PE',
      name: i18next.t('instant.goods.PE'),
      weight: 350,
      length: 120,
      width: 80,
      height: 120,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 54,
      presetDimension: 'PI',
      name: i18next.t('instant.goods.PI'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 55,
      presetDimension: 'PK',
      name: i18next.t('instant.goods.PK'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 56,
      presetDimension: 'PP',
      name: i18next.t('instant.goods.PP'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 57,
      presetDimension: 'PV',
      name: i18next.t('instant.goods.PV'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 58,
      presetDimension: 'RK',
      name: i18next.t('instant.goods.RK'),
      weight: 0,
      length: 122,
      width: 82,
      height: 93,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 59,
      presetDimension: 'RO',
      name: i18next.t('instant.goods.RO'),
      weight: 0,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 60,
      presetDimension: 'RV',
      name: i18next.t('instant.goods.RV'),
      weight: 2,
      length: 30,
      width: 20,
      height: 10,
      goodsDescription: '',
      palletFootPrints: 0.1,
      loadingMeters: 0.0
    }),
    Map({
      id: 61,
      presetDimension: 'SE',
      name: i18next.t('instant.goods.SE'),
      weight: 17000,
      length: 1320,
      width: 240,
      height: 260,
      goodsDescription: '',
      palletFootPrints: 33.0,
      loadingMeters: 13.2
    }),
    Map({
      id: 62,
      presetDimension: 'TY',
      name: i18next.t('instant.goods.TY'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    }),
    Map({
      id: 63,
      presetDimension: 'VB',
      name: i18next.t('instant.goods.VB'),
      weight: 10000,
      length: 760,
      width: 240,
      height: 260,
      goodsDescription: '',
      palletFootPrints: 19.0,
      loadingMeters: 7.6
    }),
    Map({
      id: 64,
      presetDimension: 'Z1',
      name: i18next.t('instant.goods.Z1'),
      weight: 1029,
      length: 125,
      width: 105,
      height: 90,
      goodsDescription: '',
      palletFootPrints: 1.3,
      loadingMeters: 0.5
    }),
    Map({
      id: 65,
      presetDimension: 'Z2',
      name: i18next.t('instant.goods.Z2'),
      weight: 700,
      length: 137,
      width: 55,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 0.8,
      loadingMeters: 0.3
    }),
    Map({
      id: 66,
      presetDimension: 'Z3',
      name: i18next.t('instant.goods.Z3'),
      weight: 960,
      length: 120,
      width: 105,
      height: 220,
      goodsDescription: '',
      palletFootPrints: 1.3,
      loadingMeters: 0.5
    }),
    Map({
      id: 67,
      presetDimension: 'Z4',
      name: i18next.t('instant.goods.Z4'),
      weight: 140,
      length: 100,
      width: 60,
      height: 135,
      goodsDescription: '',
      palletFootPrints: 0.6,
      loadingMeters: 0.3
    }),
    Map({
      id: 68,
      presetDimension: 'Z5',
      name: i18next.t('instant.goods.Z5'),
      weight: 225,
      length: 120,
      width: 80,
      height: 120,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 69,
      presetDimension: 'Z6',
      name: i18next.t('instant.goods.Z6'),
      weight: 450,
      length: 120,
      width: 80,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 1.0,
      loadingMeters: 0.4
    }),
    Map({
      id: 70,
      presetDimension: 'Z8',
      name: i18next.t('instant.goods.Z8'),
      weight: 80,
      length: 80,
      width: 60,
      height: 240,
      goodsDescription: '',
      palletFootPrints: 0.5,
      loadingMeters: 0.2
    }),
    Map({
      id: 71,
      presetDimension: 'ZZ',
      name: i18next.t('instant.goods.ZZ'),
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      goodsDescription: '',
      palletFootPrints: 0.0,
      loadingMeters: 0.0
    })
  ])
)

export const standardMeasurementsOld = List<ISize>([
  Map({ id: 0, presetDimension: 'custom', name: 'Custom', weight: '', length: '', width: '', height: '' }),
  Map({ id: 1, presetDimension: 'letter', name: 'Letter', weight: '1', length: '30', width: '42', height: '4' }),
  Map({ id: 2, presetDimension: 'bag', name: 'Bag', weight: '5', length: '20', width: '50', height: '30' }),
  Map({ id: 3, presetDimension: 'smallbox', name: 'Small box', weight: '3', length: '20', width: '10', height: '20' }),
  Map({
    id: 4,
    presetDimension: 'mediumbox',
    name: 'Medium box',
    weight: '10',
    length: '20',
    width: '50',
    height: '30'
  }),
  Map({ id: 5, presetDimension: 'largebox', name: 'Large box', weight: '30', length: '61', width: '35', height: '40' }),
  Map({ id: 6, presetDimension: 'tube', name: 'Tube', weight: '2', length: '80', width: '10', height: '10' }),
  Map({
    id: 12,
    presetDimension: 'quarterpallet',
    name: 'Quarter pallet',
    weight: '50',
    length: '40',
    width: '60',
    height: '50'
  }),
  Map({
    id: 7,
    presetDimension: 'halfpallet',
    name: 'Half pallet',
    weight: '100',
    length: '60',
    width: '80',
    height: '50'
  }),
  Map({
    id: 8,
    presetDimension: 'fullpallet',
    name: 'Full pallet',
    weight: '200',
    length: '80',
    width: '120',
    height: '70'
  }),
  Map({ id: 9, presetDimension: 'suitcase', name: 'Suitcase', weight: '20', length: '80', width: '50', height: '30' }),
  Map({
    id: 10,
    presetDimension: 'movingbox',
    name: 'Moving box',
    weight: '20',
    length: '50',
    width: '25',
    height: '30'
  }),
  Map({
    id: 11,
    presetDimension: 'trolley',
    name: 'Trolley',
    weight: '100',
    length: '120',
    width: '80',
    height: '180'
  })
])

export const getAvailableMeasurements = (department: Department): List<ISize> =>
  isDepartmentEligibleForPHMeasurements(department) ? parcelHubMeasurements() : standardMeasurementsOld

export const isDepartmentEligibleForPHMeasurements = (department: Department): boolean =>
  department.get('departmentType') === DepartmentType.Parcel

export interface FormMeasurement {
  id?: number
  presetDimension: PresetDimension | null
  name: string
  weight: number | string
  height: number | string
  length: number | string
  width: number | string
  goodsDescription: string
  palletFootPrints: number | null
  loadingMeters: number | null
}

export function getMeasurementVolume(measurement: FormMeasurement): number {
  const length = Number.parseInt(String(measurement.length), 10)
  const width = Number.parseInt(String(measurement.width), 10)
  const height = Number.parseInt(String(measurement.height), 10)

  if (!(Number.isNaN(length) || Number.isNaN(width) || Number.isNaN(height))) {
    return (length * width * height) / 1000
  } else {
    return 0
  }
}

function getMeasurementsTotal(
  measurements: FormMeasurement[],
  field: 'weight' | 'length' | 'width' | 'height'
): number {
  const value = measurements.map((m) => Number.parseFloat(String(m[field]))).reduce((sum, val) => sum + val, 0)
  return Number.isNaN(value) ? 0 : value
}

export function getMeasurementsTotalVolume(measurements: FormMeasurement[]): number {
  return measurements.map(getMeasurementVolume).reduce((sum, val) => sum + val, 0)
}

export function getMeasurementsTotalWeight(measurements: FormMeasurement[]): number {
  return getMeasurementsTotal(measurements, 'weight')
}
